/**
 * Notification Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SettingsData { 
    clientName?: string;
    clientEmail?: string;
    clientSubscription?: string;
    addedEmails?: string;
    removedEmails?: string;
    addedTags?: string;
    removedTags?: string;
}